import { ShieldCheckIcon, ShieldSlashIcon } from '@phosphor-icons/react';
import i18n from 'i18next';

import { Button, Text } from '@components';
import { CellType, FormActionType, VariantType } from '@enums';
import type { Column } from '@types';
import { cn, getColumnSizes } from '@utils';

export const getCdnDomainListColumns = ({ cname, isDataSubmitting, actionHandlers }): Column[] => [
  { label: i18n.t('configuration:tables.id'), value: 'id', ...getColumnSizes(50) },
  { label: i18n.t('configuration:tables.name'), value: 'name', ...getColumnSizes(100) },
  {
    label: i18n.t('configuration:tables.domain'),
    value: 'domain',
    ...getColumnSizes(140),
    className: '',
    cellType: CellType.Custom,
    format: (value, fullData) => {
      const isVerified = fullData?.cname_verified;
      const disabled = isDataSubmitting || isVerified || !cname;
      const ShieldIcon = isVerified ? ShieldCheckIcon : ShieldSlashIcon;

      return (
        <div className="flex items-center">
          <Text $level={4} color="text-black" className="font-normal truncate leading-6 select-text mr-2">
            {value}
          </Text>
          <Button
            variant={VariantType.Clean}
            className="flex-shrink-0 bg-transparent enabled:shadow-none"
            disabled={disabled}
            onClick={() => actionHandlers[FormActionType.Verification]?.handler(fullData)}
            adornment={
              <ShieldIcon
                weight="bold"
                className={cn(
                  'size-4 text-green-500',
                  (!cname || isDataSubmitting) && 'text-gray-300',
                  !disabled && 'text-red-500',
                )}
              />
            }
          />
        </div>
      );
    },
  },
  {
    label: i18n.t('configuration:tables.origin'),
    value: 'origin',
    ...getColumnSizes(70),
  },
  { label: i18n.t('configuration:tables.action'), value: 'actions', cellType: CellType.Action, ...getColumnSizes(90) },
];
